import React, { Dispatch, FC, SetStateAction } from 'react';
import {
  VariantDropdown,
  VariantTiles,
} from '@/components/common/ProductAddToCart/index';
import { VariantCircles } from '@/components/common/ProductAddToCart/VariantCircles';
import { ShopifyVariant } from '@/lib/shopify';
import { ProductVariantCopy } from '@/lib/contentful';
import { TypeProduct } from '@/core/generated-types';

interface VariantSwitcherInterface {
  selectedVariant: ShopifyVariant;
  variants: ShopifyVariant[];
  cb: Dispatch<SetStateAction<ShopifyVariant>>;
  displayVariantType: 'tile' | 'dropdown' | 'circle';
  productVariantsCopy: ProductVariantCopy | null;
  product: TypeProduct;
}

export const VariantSwitcher: FC<VariantSwitcherInterface> = ({
  displayVariantType,
  selectedVariant,
  variants,
  cb,
  productVariantsCopy,
  product,
}) => {
  const commonProps = {
    variants,
    selectedVariant,
    cb,
    productVariantsCopy,
  };

  switch (displayVariantType) {
    case 'dropdown':
      return (
        <VariantDropdown
          name="variant-select"
          id="variant-select"
          {...commonProps}
        />
      );
    case 'circle':
      return <VariantCircles product={product} {...commonProps} />;
    case 'tile':
    default:
      return <VariantTiles {...commonProps} />;
  }
};
